module.exports = {
      id: "user-usage",
      viewBox: "0 0 158 158",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#user",
      toString: function () {
        return this.url;
      }
    }